module.exports = __webpack_public_path__ + "static/media/about_black_ginssen_icon4.bf785129.png";